export const translation = {
    inspector: {
        tabTitle: 'DBT',
        githubProjectLink: 'GitHub Project',
        githubRef: 'GitHub Ref',
        dbtProject: 'DBT Project',
        dbtProjectVersion: 'DBT Project Version',
        modelLink: 'Model on GitHub',
        upstreamReferences: 'Uses',
        downstreamReferences: 'Used By'
    },
    job: {
        githubOwner: 'GitHub Owner',
        githubOwner_placeholder: 'Enter the owner of the GitHub repository',
        githubRepositoryName: 'GitHub Repository',
        githubRepositoryName_placeholder: 'Enter the GitHub repository',
        githubRef: 'GitHub Ref',
        githubRef_placeholder: '(Optional) Enter Tag, Branch or Commit',
        githubAuth: 'GitHub Authentication',
        githubAuthInfo: 'Configure the GitHub authentication under',
        githubAuthLink: 'GithHub Configuration',
        profileInfo: 'This section contains configuration values usually to be set up in your DBT profile.',
        targetDatabase: 'DBT Target Database',
        targetDatabase_placeholder: 'Enter the target database',
        targetSchema: 'DBT Target Schema',
        targetSchema_placeholder: 'Enter the target schema',
        metric: {
            projectCount: 'DBT Project Count',
            modelCount: 'DBT Model Count'
        }
    }
};
